import { useState, useEffect } from "react";
import { Root, Container, GlossaryTerm, GlossaryDefinition } from "./styles";

type GlossaryItem = {
  id: string;
  key: string;
  value: string;
};

type GlossaryPluginProps = {
  componentConfig: {
    config?: {
      cssClass?: string;
    };
  };
  getGlossaryData: () => Promise<GlossaryItem[]>;
};

export function GlossaryPluginComponent({ componentConfig, getGlossaryData }: GlossaryPluginProps) {
  const [glossaryData, setGlossaryData] = useState<GlossaryItem[]>([]);
  const [loading, setLoading] = useState(true);

  const { cssClass } = componentConfig?.config ?? {};

  useEffect(() => {
    getGlossaryData()
      .then((data) => setGlossaryData(data))
      .catch((err) => console.error("Failed to fetch glossary data:", err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    console.log("Loading....");
    return <div>Loading glossary...</div>;
  }

  if (!glossaryData || glossaryData.length === 0) {
    return <div>There is no data available</div>;
  }
  const sortedData = [...glossaryData]
    .filter((item) => item.key !== "")
    .sort((a, b) => (a.key || "").toLowerCase().localeCompare((b.key || "").toLowerCase()));

  console.log("sortedData glossary data", sortedData);

  return (
    <Root>
      <Container className={cssClass ?? ""}>
        <dl className="glossary-list">
          {sortedData.map((item) => (
            <div key={item.id}>
              <GlossaryTerm data-id={item.id} className="glossary-term">
                <p>{item.key}</p>
              </GlossaryTerm>
              <GlossaryDefinition data-id={`${item.id}-definition`} className="glossary-definition">
                <p>{item.value}</p>
              </GlossaryDefinition>
            </div>
          ))}
        </dl>
      </Container>
    </Root>
  );
}
